import { render, staticRenderFns } from "./HeatCool.vue?vue&type=template&id=008634a6&scoped=true&"
import script from "./HeatCool.vue?vue&type=script&lang=js&"
export * from "./HeatCool.vue?vue&type=script&lang=js&"
import style0 from "./HeatCool.vue?vue&type=style&index=0&id=008634a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008634a6",
  null
  
)

export default component.exports